import type {FC} from 'react';
import MenuList from './components/MenuList.tsx';
import styled from 'styled-components';
import HomeIcon from './components/HomeIcon.tsx';
import Weather from './components/Weather.tsx';

const MenuWrapper = styled.div`
    background-color: #242426;
    width: 15vw;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    border-radius: 30px;
`;

const LeftMenu: FC = () => {
    return (
        <>
            <MenuWrapper>
                <HomeIcon />
                <Weather />
                <MenuList />
            </MenuWrapper>
        </>
    );
};

export default LeftMenu;
